module.exports = __webpack_public_path__ + "img/960w.c2e3d8b.jpg";